import React, { useEffect, useState } from "react";
import Percepciones from "../../reusable/Percepciones";
import { perceptionsLAPOP as texts_es } from "../../../utils/text/graphTexts";
import { perceptionsLAPOP as texts_en } from "../../../utils/text/graphTexts_en";
import { useParams } from "react-router-dom";
import { COUNTRY_OPTIONS } from "../../../utils/constants/countryOptions";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

const LAPOPOptionsTree_ES = require("../../../utils/opinions/percepciones_barometro_americas.json");
const LAPOPOptionsTree_EN = require("../../../utils/opinions/percepciones_barometro_americas_EN.json");

export default function LAPOP({ selectedCountry }) {
  const { country } = useParams();
  const { language } = useCurrentLanguage();

  const [currentCountry, setCurrentCountry] = useState(
    selectedCountry ?? country ?? "LAC"
  );
  const [texts] = useState(language === "en" ? texts_en : texts_es);
  const [type] = useState("lapop");
  const [countryProps, setCountryProps] = useState(
    COUNTRY_OPTIONS.find(
      (opt) => opt.code === selectedCountry || opt.code === country
    )
  );
  useEffect(() => {
    if (selectedCountry) {
      setCurrentCountry(selectedCountry);
      setCountryProps(
        COUNTRY_OPTIONS.find((opt) => opt.code === selectedCountry)
      );
    }
  }, [selectedCountry]);

  return (
    <Percepciones
      type={type}
      country={currentCountry}
      countryProps={countryProps}
      optionsTree={
        language === "en" ? LAPOPOptionsTree_EN : LAPOPOptionsTree_ES
      }
      title={texts.boxTitle}
      description={texts.description}
      methodology={texts.methodology}
      color="var(--blue-primary)"
      language={language}
      downloadableCardID={type}
      downloadableCardFileName={"LAPOP.png"}
    />
  );
}
